export default "__VITE_ASSET__BFcVdsNz__"